





import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class MdcIcon extends Vue{
  @Prop({default:'i'}) tag!:string
  get cssClass(){
    return {}
  }
}
